var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-3"},[_c('form-question-free-text',{attrs:{"id":_vm.id_computed,"request_form":_vm.request_form,"required":""},on:{"update-value":_vm.updateValue}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }